export default "__VITE_ASSET__11a1e9e6__"